import SlsPicClient from '@/api/Operacoes/sls-pic.client';
import Store from '@/store';

import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class SLSPicService {
  constructor() {
    this.client = new SlsPicClient();
    this.notify = new Notifier();
    this.vuex = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.notify.error(error, 'Erro ao listar as Pic');
    }
  }

  async findByUsuario(queries) {
    try {
      const { data } = await this.client.findByUsuario(queries);
      return data;
    } catch (error) {
      this.notify.error(error, 'Erro ao listar as Pic');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.notify.error(error, 'Erro ao criar Pic');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.notify.error(error, 'Erro ao buscar Pic');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.notify.error(error, 'Erro ao atualizar Pic');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.notify.error(error, 'Erro ao deletar Pic');
    }
  }

  async getPicPedidos(params = this.vuex.getters['PicStore/GET_FILTERS']) {
    // Funcionalidade PIC parametrizada por tenant (PIC_ATIVO, padrão desligado):
    // quando inativa, não busca PICs (nenhum widget/modal deve aparecer).
    if (this.vuex.getters['preferencias/picAtivo'] !== true) {
      this.vuex.commit('PicStore/SET_PIC', { pic_genericas: [], pic_cliente: [] });
      return null;
    }
    if (!params.estabelecimentoid) {
      // throw this.notify.warning('Estabelecimento não informado')
      console.log('Estabelecimento não informado');
    }
    if (!params.condicaopagamentoid) {
      // throw this.notify.warning('Condição de pagamento não informada')
      console.log('Condição de pagamento não informada');
    }
    if (!params.clienteid) {
      //    throw this.notify.warning('Cliente não informado')
      console.log('Cliente não informado');
    }
    if (!params.tabelaprecoId) {
      // throw this.notify.warning('Tabela de preço não informada')
      console.log('Tabela de preço não informada');
    }
    this.vuex.commit('PicStore/SET_LOADING', true);
    const paramsPicPedido = {
      estabelecimentoid: params.estabelecimentoid,
      condicaopagamentoid: params.condicaopagamentoid,
      clienteid: params.clienteid,
      tabelaprecoId: params.tabelaprecoId,
      tipopedidoid: params.tipopedidoid,
      itemid: params.itemid,
    };
    let { piccliente, picgenerica } = await this.client.getPicFindBySituacao(paramsPicPedido)
      .catch((error) => {
        throw this.notify.error(error);
      });
    piccliente = piccliente || [];
    picgenerica = picgenerica || [];
    this.vuex.commit('InfoPedido/SET_OPTIONS_PIC_PEDIDO', piccliente.concat(picgenerica));
    this.vuex.commit('PicStore/SET_PIC', {
      pic_genericas: picgenerica,
      pic_cliente: piccliente,
    });
    this.vuex.commit('PicStore/SET_LOADING', false);
    return {
      pic: {
        pic_genericas: picgenerica,
        pic_cliente: piccliente,
      },
    };
  }
}
